import Vue from "vue";
import Axios from "axios";
import router from "@/router";
import store from "@/store";
import {
  displayErrors,
  displayInfo,
  backendAddress,
  getTokenFromConfig
} from "@/utils/helpers";

backendAddress("/api").then(address => (Axios.defaults.baseURL = address));
getTokenFromConfig().then(token => {
  Axios.interceptors.request.use(config => {
    if (!config.url.toUpperCase().includes("GETSTATUSOPERATIONS") && !config.url.toUpperCase().includes("UTILITY")) {
      store.dispatch("loading");
    }
    config.headers.common["Authorization"] =
      "Bearer " + sessionStorage.getItem("token");
    return config;
  });
});

Axios.interceptors.response.use(
  response => {
    store.dispatch("loaded");
    return response;
  },
  error => {
    store.dispatch("loaded");
    if (error.response) {
      if (error.response.status == 400) {
        if (error.response.data.message == "Błąd połączenia.") {
          router.push({
            path: "/connectionError"
          });
        }
        if (error.response.data.message == "PageIsNotEnable") {
          router.push({
            path: "/PageDisabled"
          });
        }
        //displayErrors(error);
      }
      // if (error.response.status == 401) {
      //   router.push({
      //     path: "/login"
      //   });
      // }
      if (error.response.status == 403) {
        this.$store.dispatch("logout");
        router.push({
          path: "/forbidden"
        });
      }
      if (error.response.status == 404) {
        var url = error.request.responseURL.toUpperCase();
        if (
          !url.includes("/STATIC/") &&
          !url.includes("CORS-ANYWHERE.HEROKUAPP.COM")
        ) {
          router.push({
            path: "/notfound"
          });
        }
      }
    } else {
      displayInfo("Brak połączenia z serwerem");
    }
    return Promise.reject(error);
  }
);

Vue.$http = Axios;
Vue.prototype.$http = Axios;
